import videojs, {VideoJsPlayer, VideoJsPlayerOptions} from 'video.js';
import VideoException from 'app/exceptions/VideoException';

export default class VideoJsPlayerFactory {
  private static instance: VideoJsPlayer | null;

  static create(onReady: () => void): VideoJsPlayer {
    const videoElement = document.getElementById('content_video');
    if (!videoElement) {
      throw new VideoException('No element found with id "content_video"');
    }
    const vjsOptions: VideoJsPlayerOptions = {
      controls: false, // show controls for the player
      userActions: {
        doubleClick: false, // disable default fullscreen on double click
      },
      responsive: true,
      fill: true,
      preload: 'auto', // preload video if browser accepts preloading (some mobile browsers don't)
      language: 'de',
      autoplay: false,
    };

    VideoJsPlayerFactory.instance = videojs(videoElement, vjsOptions, onReady);
    return VideoJsPlayerFactory.instance;
  }

  static getInstance(): VideoJsPlayer {
    if (!VideoJsPlayerFactory.instance) {
      throw new VideoException('No instance of video.js-player found!');
    }
    return VideoJsPlayerFactory.instance;
  }

  static destroy(): void {
    const player = VideoJsPlayerFactory.instance;
    if (!player) {
      throw new VideoException('On destroy: No instance of video.js-player found!');
    }
    player.ready(() => {});
    player.dispose();
    VideoJsPlayerFactory.instance = null;
  }
}
